import React, { useState, useEffect } from "react";
import { Portal, Box, useDisclosure } from "@chakra-ui/react";
import Footer from "../../components/footer/FooterAdmin";
import Navbar from "../../components/navbar/NavbarAdmin";
import Sidebar from "../../components/sidebar/Sidebar";
import { SidebarContext } from "../../contexts/SidebarContext";
import { Navigate, Route, Routes, useLocation, useNavigate, useParams } from "react-router-dom";
import { getRoutes } from "../../routes";
import { getBusinessSlug } from "../../utils/slugify";
import WaitronAssistant from "../../components/assistant/WaitronAssistant";

export default function Dashboard(props) {
  const { ...rest } = props;
  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const { onOpen } = useDisclosure();
  const location = useLocation(); 
  const navigate = useNavigate();
  const { businessName } = useParams();

  useEffect(() => {
    const checkAuth = async () => {
      // Token artık httpOnly cookie'de, localStorage'dan kontrol etme
      const restaurantId = localStorage.getItem('restaurantId');
      const business = localStorage.getItem('business');
      
      if (!business || !restaurantId) {
        navigate('/auth/sign-in');
        return;
      }
      // URL'de business name yoksa veya yanlışsa, doğru URL'e yönlendir
      const currentBusinessSlug = getBusinessSlug();
      if (currentBusinessSlug) {
        // Eğer URL'de business name yoksa veya yanlışsa, doğru URL'e yönlendir
        if (!businessName || businessName !== currentBusinessSlug) {
          const currentPath = location.pathname.replace(/^\/admin\/[^/]+/, '');
          navigate(`/admin/${currentBusinessSlug}${currentPath || '/panel'}`, { replace: true });
        }
      }
    };

    checkAuth();
  }, [navigate, businessName, location.pathname]);

  const routes = getRoutes();
  
  const getActiveRoute = (routesList) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routesList.length; i++) {
      if (routesList[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routesList[i].items);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routesList[i].category) {
        let categoryActiveRoute = getActiveRoute(routesList[i].items);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        // Business name ile başlayan layout'ları kontrol et
        const routePath = routesList[i].layout + routesList[i].path;
        if (location.pathname.includes(routePath) || 
            (routesList[i].layout && location.pathname.includes(routesList[i].path))) {
          return routesList[i].name;
        }
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routesList) => {
    let activeNavbar = false;
    for (let i = 0; i < routesList.length; i++) {
      if (routesList[i].collapse) {
        let collapseActiveNavbar = getActiveNavbar(routesList[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routesList[i].category) {
        let categoryActiveNavbar = getActiveNavbar(routesList[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        const routePath = routesList[i].layout + routesList[i].path;
        if (location.pathname.includes(routePath) || 
            (routesList[i].layout && location.pathname.includes(routesList[i].path))) {
          return routesList[i].secondary;
        }
      }
    }
    return activeNavbar;
  };
  const getActiveNavbarText = (routesList) => {
    let activeNavbar = false;
    for (let i = 0; i < routesList.length; i++) {
      if (routesList[i].collapse) {
        let collapseActiveNavbar = getActiveNavbarText(routesList[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routesList[i].category) {
        let categoryActiveNavbar = getActiveNavbarText(routesList[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        const routePath = routesList[i].layout + routesList[i].path;
        if (location.pathname.includes(routePath) || 
            (routesList[i].layout && location.pathname.includes(routesList[i].path))) {
          return routesList[i].messageNavbar;
        }
      }
    }
    return activeNavbar;
  };
  const renderRoutes = (routesList) => {
    return routesList.map((route, key) => {
      // Business name ile başlayan layout'ları kontrol et
      if (route.layout && route.layout.startsWith("/admin")) {
        return (
          <Route path={`${route.path}`} element={route.component} key={key} />
        );
      }
      if (route.collapse) {
        return renderRoutes(route.items);
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = "ltr";

  return (
    <Box>
      <Box>
        <SidebarContext.Provider
          value={{
            toggleSidebar,
            setToggleSidebar,
          }}
        >
          <Sidebar routes={routes} {...rest} />
          <Box
            float="right"
            minHeight="100vh"
            height="100%"
            overflow="auto"
            position="relative"
            maxHeight="100%"
            w={{ base: "100%", xl: "calc( 100% - 290px )" }}
            maxWidth={{ base: "100%", xl: "calc( 100% - 290px )" }}
            transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
            transitionDuration=".2s, .2s, .35s"
            transitionProperty="top, bottom, width"
            transitionTimingFunction="linear, linear, ease"
          >
            <Portal>
              <Box>
                <Navbar
                  onOpen={onOpen}
                  logoText={"Horizon UI Dashboard PRO"}
                  brandText={getActiveRoute(routes)} 
                  secondary={getActiveNavbar(routes)}
                  message={getActiveNavbarText(routes)}
                  fixed={fixed}
                  {...rest}
                />
              </Box>
            </Portal>

            {location.pathname !== "/admin/full-screen-maps" ? (
              <Box
                mx="auto"
                p={{ base: "20px", md: "30px" }}
                pe="20px"
                minH="100vh"
                pt="50px"
              >
                <Routes>
                  {renderRoutes(routes)}
                  <Route
                    path="/"
                    element={<Navigate to={`/admin/${businessName || getBusinessSlug() || 'panel'}/panel`} replace />}
                  />
                </Routes>
              </Box>
            ) : null}
            <Box>
              <Footer />
              {/* Premium işletmeler için Waitron asistan (buton sabit, içeride premium kontrolü var) */}
              <WaitronAssistant />
            </Box>
          </Box>
        </SidebarContext.Provider>
      </Box>
    </Box>
  );
}